import React, {useEffect,useState} from 'react'
import firebaseApp from './firebaseApp'
import CircularProgress from "@material-ui/core/CircularProgress";
import loadingIcon from "./assets/loadingIcon.png"
import {refreshToken} from "./api/gmail-api"

export const AuthContext = React.createContext();

export const AuthProvider = ({children}) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [pending, setPending] = useState(true);

    useEffect(() =>{
        firebaseApp.auth().onAuthStateChanged((user)=>{
            setCurrentUser(user)
            setPending(false)
            if (user){
                window.gapi.load("client:auth2",()=>{
                    const config =  {
                        response_type: 'permission',
                        scope: "https://www.googleapis.com/auth/gmail.modify",
                        client_id: "897894816961-v2mhc06e43r07gjtmnmeg0o2rbg0emgi.apps.googleusercontent.com",
                        login_hint: user.email,
                        prompt: 'none',
                    }
                    window.gapi.auth2.authorize(config, function(response) {
                        let initConfig = {discoveryDocs:[
                            "https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"
                            ]}
                        window.gapi.client.init(initConfig).then(()=>{})
                    })
                })

                setInterval(()=>{refreshToken(user.email)}, 2700000)
            }
        });
    },[]);

    if(pending){
        return (
            <>
            <div className="loadingMsg">
                <img src={loadingIcon} alt="loadingIcon" className="loadingImg"/>
                <p>Loading</p>
                <CircularProgress value={40} className="processImg"/>
            </div>
            </>
        )
    }
    

    return (
        <AuthContext.Provider
            value={
                {currentUser}
            }
        >
            {children}
        </AuthContext.Provider>
    )
};